import React from "react"
import ReactDOMServer from "react-dom/server";
import { AiFillCaretDown } from "react-icons/ai";
import { getTitle } from "../../helpers/getTitle";
import { DIMENSIONS } from "utils/Dimensions";
import  FileColumnRenderer from "./../FileOrAttachment/FileColumnRenderer";
import { formatDate, formatTime } from "../../helpers/dateFormatter";
var clickCount = 0, previousClickedCell=""

export default class LookupColumnRenderer {

  showDownArrow(params){
    // if(params.value !== undefined ){
      return ReactDOMServer.renderToStaticMarkup(<AiFillCaretDown />);
    // }
    // return ""
  }

  init(params) {
    this.params = params;
    // const value = params?.value?.value ? 
    //               params.value.value :
    //               params.value ?? "";
    let value =
      typeof params.value == "undefined"
        ? ""
        : typeof params.value == "string"
        ? params.value
        : typeof params.value == "object"
        ? params.value.value
        : "";
    const columnType = params?.columnOptions?.column_type ;

    this.clickHandler = function clickHandler(){
      clickCount=clickCount+1
      if(clickCount>1 && previousClickedCell===params.api.getFocusedCell().rowIndex){
        params.api.startEditingCell({
          colKey: params.colDef.colId,
          rowIndex: params.rowIndex,
        });
        clickCount=0 
      }
      else{
        previousClickedCell = params.api.getFocusedCell().rowIndex
      }
    } 

    this.cellValueClickHandler = function cellValueClickHandler() {
      if (this.rowDataViewWin) {
        this.rowDataViewWin.destroy();
      }
      let fileNames = "";
      try{
        if(columnType === "file" && value){
          const namesArray = JSON.parse(value || "[]");
          fileNames = namesArray.map(i=>i.name).join(" ");
        }
      }
      catch(e){
        fileNames=value;
      }
      this.rowDataViewWin = Ext.create("TL.RowDataViewWindow", {
        modal: true,
        autoHeight: true,
        autoScroll: true,
        minWidth: 900,
        minHeight: 300,
        rowId: params.colDef.store.isSubsheet ? params.data?.["column_" + params.columnId + "_" + params.colDef?.store?.parentColumnId + "_reference_id"] : params.data?.["column_" + params.columnId + "_reference_id"],
        listId: params.columnOptions.source_list_id,
        columnId: params.columnOptions.source_column_id,
        titleValue: columnType === "file" ? fileNames : value,
      });
      this.rowDataViewWin.show();
    };
    if (value != "+r0w") {
      this.htmlElement = document.createElement("div");
      this.htmlElement.className = "dropDownCell lookupCell";
      this.htmlElement.title = getTitle(params, params.cellMetaData);
      this.htmlElement.onclick = this.clickHandler;
      if (
        (params.data?.["column_" + params.columnId + "_reference_id"] &&
        params.data?.["column_" + params.columnId + "_reference_id"] !== "0") ||
        (params.colDef?.store?.isSubsheet &&
        params.data?.["column_" + params.columnId + "_" + params.colDef?.store?.parentColumnId + "_reference_id"] &&
        params.data?.["column_" + params.columnId + "_" + params.colDef?.store?.parentColumnId + "_reference_id"] !== "0")
      ) {
        this.cellValueElement = document.createElement("a");
        this.cellValueElement.onclick = this.cellValueClickHandler;
      } else {
        this.cellValueElement = document.createElement("span");
      }
      this.htmlElement.style.cssText = "line-height:normal";
          // "line-height:" +
          // (params.node.rowHeight <= DIMENSIONS.cell_height_compact
          //   ? "normal"
          //   : "");
      let options = this.params?.columnRaw?.options || {};
      if (
        options &&
        options.hasOwnProperty("column_type") &&
        options.column_type == "percentage" &&
        String(value).length > 0 &&
        !isNaN(value)
      ) {
        let decimals = String(value).includes(".") ? String(value).split(".")[1].length : 2;
        value = (value * 100).toFixed(decimals - 2) + " %";
      }
    
      if (
        options &&
        options.hasOwnProperty("column_type") &&
        (options?.column_type == "date" || options?.column_type == "datetime") &&
        String(value).length > 0
      ) {
        let sourceColumnTypeID = options?.column_type == "date" ? "4" : "16";
        let dateFormat = formatDate(
          value,
          "YYYY-MM-DD",
          options?.format
            ? options?.format
            : sourceColumnTypeID == "4"
            ? "M j, Y"
            : "M j, Y g:iA"
        );
        let timeFormat = formatTime(value, sourceColumnTypeID);
        value =
          sourceColumnTypeID == "4" ? dateFormat : dateFormat + " " + timeFormat;
      }

      try{
        if(columnType === "file" && value){
          const imagesContainer = FileColumnRenderer(params,"true");
          this.cellValueElement.innerHTML = `${imagesContainer}`;
          this.cellValueElement.childNodes[0].style.width="auto";
          let svgFileNodes =  this.cellValueElement.childNodes[0].querySelectorAll(".fiv-sqo");
          if(svgFileNodes && svgFileNodes.length>0){
            svgFileNodes = [...svgFileNodes];
            svgFileNodes.map(imageNode=>{
              imageNode.style.fontSize="0px";
              imageNode.setAttribute("forLookup","true");
            });
          }
        }
        else{
          this.cellValueElement.innerHTML = `${value}`;
        }
      }
      catch(e){
        this.cellValueElement.innerHTML = `${value}`;
      } 

    
      this.dropDownElement = document.createElement("div");
      this.dropDownElement.innerHTML = `<div class="drop_down_arrow">
                                        ${this.showDownArrow(params)}
                                        </div>`;
      const dropDownContainer = this.dropDownElement.querySelector(".drop_down_arrow");
      dropDownContainer.style.margin = "auto";  
      dropDownContainer.style.position = "static";
      this.cellValueElement.style.whiteSpace = "nowrap";
      this.cellValueElement.style.overflowX = "hidden";
      // this.cellValueElement.style.textOverflow = "ellipsis";
      this.htmlElement.appendChild(this.cellValueElement);
      this.htmlElement.appendChild(this.dropDownElement);
      this.htmlElement.style.justifyContent = "space-between";
    }
  }

  getGui() {
    return this.htmlElement;
  };

  destroy() {
    if (this.rowDataViewWin) {
      this.rowDataViewWin.destroy();
    }
    clickCount = 0;
  }
}